var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHubInscanShipmentsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F4F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 41.3335C26.9091 41.3335 25.8669 40.8932 23.7826 40.0128C18.5942 37.8211 16 36.7252 16 34.8819C16 34.3658 16 25.4195 16 21.3335M28 41.3335C29.0909 41.3335 30.1331 40.8932 32.2175 40.0128C37.4059 37.8211 40 36.7252 40 34.8819V21.3335M28 41.3335V27.1399",
    stroke: "#2B3674",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1012 24.9217L19.2063 23.037C17.0688 22.0026 16 21.4855 16 20.6665C16 19.8475 17.0688 19.3304 19.2063 18.296L23.1012 16.4113C25.5051 15.2481 26.7071 14.6665 28 14.6665C29.2929 14.6665 30.4949 15.2481 32.8988 16.4113L36.7937 18.296C38.9312 19.3304 40 19.8475 40 20.6665C40 21.4855 38.9312 22.0026 36.7937 23.037L32.8988 24.9217C30.4949 26.0849 29.2929 26.6665 28 26.6665C26.7071 26.6665 25.5051 26.0849 23.1012 24.9217Z",
    stroke: "#2B3674",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 28L22.6667 29.3333",
    stroke: "#2B3674",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6663 17.3335L21.333 24.0002",
    stroke: "#2B3674",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubInscanShipmentsIcon);
export default __webpack_public_path__ + "static/media/HubInscanShipmentsIcon.8ae04abcd045e28417ef06460aa00d31.svg";
export { ForwardRef as ReactComponent };